import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { InAppPopupPage } from './in-app-popup.page';

import { BuyPage } from '../../popups/buy/buy.page';
import { BuyPageModule } from '../../popups/buy/buy.module';
import { ComponentsModule } from '../../components/components.module';

const routes: Routes = [
  {
    path: '',
    component: InAppPopupPage
  }
];

@NgModule({
  entryComponents:[
    BuyPage
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    BuyPageModule,
    ComponentsModule
  ],
  declarations: [InAppPopupPage]
})
export class InAppPopupPageModule {}
